export const downloadFile = async (uri: string, filename = '') => {
  try {
    const blob = await fetch(uri).then(resp => resp.blob());

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.log(err);
  }
};
